<wr-new-data-table
  [insideCard]="false"
  localStorageIdentifier="building-equipment-protocols-tab"
  [loadItemsFunction]="loadItems"
  [getCountFunction]="getCount"
  (lineClick)="navigateToDetail($event)"
  (newClick)="createProtocol()"
  [form]="form"
  [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label">Protokoll-Typ</label>
          <nb-select formControlName="protocolTypeId" placeholder="Alle">
            <nb-option [value]="null">Alle</nb-option>
            <nb-option *ngFor="let type of protocolTypes$ | async" [value]="type.id">{{ type.name }}</nb-option>
          </nb-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template dataColumn let-item key="protocolType" exportKey="protocolType.name" display="Typ">
    <wr-protocol-type-badge [protocolType]="item.protocolType"></wr-protocol-type-badge>
  </ng-template>
  <ng-template dataColumn let-item key="status" display="Status">
    <span class="status-badge"
          [class.status-badge--draft]="item.status === 'DRAFT'"
          [class.status-badge--published]="item.status === 'PUBLISHED'">
      <nb-icon [icon]="item.status === 'PUBLISHED' ? 'checkmark-circle-2-outline' : 'eye-off-outline'" pack="eva"></nb-icon>
      {{ item.status === 'PUBLISHED' ? 'Veröffentlicht' : 'Entwurf' }}
    </span>
  </ng-template>
  <ng-template dataColumn let-item key="created" display="Erstellt">
    {{ item.created | date:'dd.MM.yyyy' }}
  </ng-template>
  <ng-template dataColumn let-item key="creator" [exportValue]="exportCreatorName" display="Erstellt von">
    <nb-user size="small"
             [name]="getCreatorName(item)"
             [picture]="getUserProfile(item.creator)">
    </nb-user>
  </ng-template>
</wr-new-data-table>
